import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import { cn } from '@/lib/cn';

/**
 * The left submenu for `/settings/*` (§ Instellingen, PLAN-FASE2.md WP-08):
 * four tabs confirmed in the flowchart.
 */
const ITEMS = [
  { id: 'profile', labelKey: 'settings.nav.profile', to: '/settings', end: true },
  { id: 'branding', labelKey: 'settings.nav.branding', to: '/settings/branding', end: true },
  { id: 'privacy', labelKey: 'settings.nav.privacy', to: '/settings/privacy', end: true },
  { id: 'modules', labelKey: 'settings.nav.modules', to: '/settings/modules', end: true },
] as const;

export function SettingsNav({ onNavigate }: { onNavigate?: (() => void) | undefined }) {
  const { t } = useTranslation();

  return (
    <nav aria-label={t('settings.nav.label')}>
      <ul className="flex list-none flex-col gap-1 p-0">
        {ITEMS.map((item) => (
          <li key={item.id}>
            <NavLink
              to={item.to}
              end={item.end}
              onClick={onNavigate}
              className={({ isActive }) =>
                cn(
                  'rounded-pill flex h-9 items-center justify-between gap-2 px-3 text-sm',
                  'hover:bg-mint-tint transition-colors motion-reduce:transition-none',
                  'focus-visible:ring-accent focus-visible:ring-offset-paper focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none',
                  isActive ? 'bg-mint text-ink font-semibold' : 'text-ink',
                )
              }
            >
              {t(item.labelKey)}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
